import { incYenOf, incOf } from '../lib/pricing';
export const hotelHero = {
  title: 'ホテル・旅館向け 法人研修',
  titleEn: 'FOR HOTELS & RYOKAN',
  lead: 'ホテル・旅館向け研修は、バトラーサービスと客室接遇の型を執事教育の手法で短期間に整えるプログラムです。',
};

export const hotelTrustBadges = [
  {
    icon: 'ri-building-2-line',
    text: 'スイート・ラウンジ運営の型を確立',
  },
  {
    icon: 'ri-map-pin-user-line',
    text: '出張型で貴館の現場に合わせた訓練',
  },
  {
    icon: 'ri-user-star-line',
    text: '執事養成課程と同一の講師陣',
  },
];

export const hotelPainPoints = [
  {
    icon: 'ri-hotel-line',
    text: '開業・改装に向けてバトラー／クラブラウンジ運営の型が必要だが、社内に指導できる人材がいない',
  },
  {
    icon: 'ri-global-line',
    text: '海外VIP・インバウンド富裕層の期待値が上がっており、従来の接遇では満足されなくなっている',
  },
  {
    icon: 'ri-contrast-drop-line',
    text: '接遇品質がスタッフごとにばらつき、ゲストアンケートの評価にも差が出ている',
  },
  {
    icon: 'ri-file-text-line',
    text: 'OJT頼みでサービスが言語化・標準化されておらず、人が替わると品質が維持できない',
  },
];

export const whyButlerWorks = [
  {
    icon: 'ri-shield-user-line',
    title: 'バトラーサービスの原型',
    description:
      '執事教育は「一人のゲストに仕え切る」技術の体系であり、バトラーサービスの原型そのものです。立ち居振る舞いから先回りの準備まで、バトラーに求められるすべての基盤を一貫したメソッドで習得できます。',
  },
  {
    icon: 'ri-tools-line',
    title: '座学2割・実技8割の訓練',
    description:
      '客室・ラウンジを想定した動作訓練を中心に、実際に体を動かして型を覚えます。頭で理解するだけでなく、身体が自然に動くレベルまで反復することで、研修翌日から現場で再現できる品質を目指します。',
  },
  {
    icon: 'ri-book-open-line',
    title: '「型」の言語化と再現性',
    description:
      '執事教育の強みは、勘や経験則に頼らず「なぜその所作なのか」を言語化して伝えられることです。研修後も社内で教育・点検できる基準としてお使いいただけるよう、型を明文化してお渡しします。',
  },
];

export const recommendedPrograms = [
  {
    title: '半日プラン例',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    modules: 'M1（立ち居振る舞い）＋ M3（ティー＆テーブル実技）',
    description:
      'バトラーサービスの基本所作とティーサービスの実技に集中する短期プランです。開業後のブラッシュアップ研修や、まずは試行的に導入したい場合に適しています。',
  },
  {
    title: '1日プラン例',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    modules: 'M1 ＋ M2（VIP対応の原則）＋ M3 ＋ M4（想定外対応ロールプレイング）',
    description:
      '立ち居振る舞いからVIP対応、ロールプレイングまで、バトラーサービスの基盤を1日で網羅する推奨プランです。',
    recommended: true,
  },
  {
    title: '開業前集中（3日間）',
    duration: '18時間（3日間）',
    price: incYenOf('ct-single-intensive3'),
    modules: '全6モジュール ＋ 貴館の動線に合わせた通し稽古',
    description:
      '開業準備に特化した集中プログラムです。全モジュールを修めた上で、実際の客室・ラウンジの動線を使った総合演習を行い、開業初日から一貫したバトラーサービスを提供できる体制を整えます。',
  },
];

export const hotelScenarios = [
  {
    number: '01',
    title: 'スイートでのウェルカムティー',
    description:
      'チェックイン時の客室案内から、トレイの持ち方・置き方、ティーカップの向き、注ぎの所作、退出までの一連の流れを客室想定のセッティングで反復練習します。ゲストの荷物やコートの扱い方も含め、スイートサービスに求められる「静かで無駄のない動き」を体得します。',
    imageSeq: 'hotel-scenario-1',
  },
  {
    number: '02',
    title: 'インルームダイニング',
    description:
      'ルームサービスワゴンの押し方・止め方、卓上セッティングの手順、料理の説明と配膳、ゲストが食事を終えるタイミングを見極めた下膳まで、インルームダイニングの全工程を実技で確認します。細かな所作の積み重ねがゲストの満足度を左右することを実感できる演習です。',
    imageSeq: 'hotel-scenario-2',
  },
  {
    number: '03',
    title: 'VIPのお出迎え',
    description:
      '車寄せでの第一声から、エレベーターまでのエスコート、客室到着後のご案内まで、VIPゲストを迎える一連の動線をロールプレイングします。声がけのタイミング、距離感、荷物の預かり方など、ゲストに「このホテルなら安心だ」と思わせる所作を訓練します。',
    imageSeq: 'hotel-scenario-3',
  },
];

export const hotelTargetRoles = [
  'バトラー',
  'コンシェルジュ',
  'クラブラウンジ係',
  '料飲サービス',
  'フロント',
  '客室係',
  '新入社員研修担当',
];

export const hotelPricingPlans = [
  {
    name: '半日プラン',
    duration: '3時間',
    price: incYenOf('ct-single-halfday'),
    note: '2モジュール選択',
  },
  {
    name: '1日プラン',
    duration: '6時間',
    price: incYenOf('ct-single-fullday'),
    note: '4モジュール選択',
    recommended: true,
  },
  {
    name: '2日間パッケージ',
    duration: '12時間（2日間）',
    price: incYenOf('ct-single-2day'),
    note: '全6モジュール受講可',
  },
  {
    name: '開業前集中',
    duration: '18時間（3日間）',
    price: incYenOf('ct-single-intensive3'),
    note: '開業準備に特化した集中設計',
  },
  {
    name: '継続プログラム',
    duration: '月1回半日×6ヶ月',
    price: incYenOf('ct-advisory-continuous6'),
    note: '定着と改善を繰り返す長期設計',
  },
];

export const hotelPricingConditions = {
  dispatch: '出張時の交通費・宿泊費は実費別途',
  capacity: '推奨12名まで（超過は2班制等をご提案）',
  payment: 'お支払いは請求書払い（銀行振込）。分割払い・クレジットカードはご利用いただけません。',
  cancel: 'キャンセルについて：実施7営業日前まで無償で日程変更可。6営業日前〜前々日は料金の50％、前日・当日は100％を申し受けます。',
};

export const hotelFlowSteps = [
  {
    step: '01',
    title: 'お問い合わせ',
    description: 'フォームまたはお電話・メールにてご連絡ください。',
  },
  {
    step: '02',
    title: 'ヒアリング',
    description:
      '対象人数・課題・希望時期などをオンラインまたはお電話で伺います。開業前の場合は開業予定日もお聞かせください。',
  },
  {
    step: '03',
    title: 'プログラム提案・お見積り',
    description:
      'ヒアリング内容をもとに、貴館に最適な研修プログラムとお見積りをご提案します。',
  },
  {
    step: '04',
    title: '実施',
    description:
      '出張または来校にて研修を実施します。出張型では実際の客室やラウンジで訓練します。',
  },
  {
    step: '05',
    title: '実施後レポート',
    description: '研修の総括と改善提案をまとめたレポートをお届けします。',
  },
];

export const facilityTypeOptions = [
  { value: '', label: '選択してください' },
  { value: 'city-hotel', label: 'シティホテル' },
  { value: 'resort', label: 'リゾート' },
  { value: 'ryokan', label: '旅館' },
  { value: 'pre-opening', label: '開業準備中' },
];

export const hotelFormatOptions = [
  { value: '', label: '選択してください' },
  { value: 'dispatch', label: '出張' },
  { value: 'onsite', label: '来校' },
  { value: 'undecided', label: '未定' },
];

export const hotelFaqs = [
  {
    question: '執事の資格が取れる研修ですか？',
    answer:
      'いいえ。執事の接遇スキルに基づくビジネスマナー研修であり、資格を付与するものではありません。ご希望に応じて受講証（参加証明）を発行します。',
  },
  {
    question: '開業前の集中研修はできますか？',
    answer:
      'はい。開業前集中（3日間）プランをご用意しています。開業日程に合わせ、複数週への分割実施も可能です。',
  },
  {
    question: '実際の客室やラウンジで実施できますか？',
    answer:
      'はい、出張型で貴館の現場での実施に対応します。実際の動線で訓練することで、研修翌日からの再現性が高まります。',
  },
  {
    question: '外国語での研修は可能ですか？',
    answer:
      '研修は日本語で実施します。海外ゲスト対応で使う英語の接遇表現を扱いたい場合は、ヒアリング時にご相談ください。',
  },
];

export const hotelRelatedPages = [
  {
    title: '高級レジデンス',
    description: 'コンシェルジュ・フロントの接遇品質を統一',
    href: '/corporate/residence',
  },
  {
    title: '金融・プライベートバンク',
    description: '富裕層営業の信頼を所作から築く',
    href: '/corporate/finance',
  },
  {
    title: '百貨店外商・高級小売',
    description: 'お得意様対応と訪問の作法',
    href: '/corporate/retail',
  },
  {
    title: 'ラグジュアリー営業',
    description: '高級車・宝飾・不動産の商談体験を設計',
    href: '/corporate/luxury-sales',
  },
  {
    title: '医療・美容クリニック',
    description: '自由診療の接遇を院内に定着',
    href: '/corporate/clinic',
  },
  {
    title: '自動車・モビリティ',
    description: 'ブランド体験の接遇を高める',
    href: '/corporate/automotive',
  },
  {
    title: 'ハイヤー・送迎',
    description: '乗降の所作と車内の気配りを磨く',
    href: '/corporate/chauffeur',
  },
];